import { Group } from "@mantine/core";
import logo2 from "../../assets/images/onset-logo.svg";
import logo2Light from "../../assets/images/onset-logo-light.svg";

export function Logo({ colorScheme }) {
  return (
    <Group sx={{ position: "relative" }} ml={11}>
      <img
        src={colorScheme === "dark" ? logo2 : logo2Light}
        height="30"
        alt="Altitude logo"
      />
    </Group>
  );
}
